import { ApolloProvider } from "@apollo/react-hooks";
import { InMemoryCache } from "apollo-cache-inmemory";
import ApolloClient from "apollo-client";
import { ApolloLink } from "apollo-link";
import { Amplify } from "@aws-amplify/core";
import { createAuthLink } from "aws-appsync-auth-link";
import { createSubscriptionHandshakeLink } from "aws-appsync-subscription-link";
import React from "react";
import ReactDOM from "react-dom";
import App from "./App";
import aws_exports from "./aws-exports";
import "./index.css";
import { unregister } from "./serviceWorker";
import ReactGA from "react-ga";
import { fetchAuthSession } from 'aws-amplify/auth';

Amplify.configure({
  ...aws_exports,
  Analytics: {
    disabled: true,
  }
});

// Update to use the new API.REST structure
const config = {
  API: {
    GraphQL: {
      endpoint: aws_exports.aws_appsync_graphqlEndpoint,
      region: aws_exports.aws_appsync_region,
      authenticationType: aws_exports.aws_appsync_authenticationType
    },
    REST: Object.fromEntries(
      (aws_exports.aws_cloud_logic_custom || []).map(api => [
        api.name,
        {
          endpoint: api.endpoint,
          region: api.region,
          custom_header: api.name === "AdminQueries" ? async () => ({
            "Content-Type": "application/json",
            Authorization: `${(await fetchAuthSession()).tokens.accessToken.toString()}`
          }) : undefined
        }
      ])
    )
  }
};

const url = config.API.GraphQL.endpoint;
const region = config.API.GraphQL.region;
const auth = {
  type: config.API.GraphQL.authenticationType,
  jwtToken: async () => {
    const { tokens } = await fetchAuthSession();
    return tokens.idToken.toString();
  }
};

const link = ApolloLink.from([
  createAuthLink({ url, region, auth }),
  createSubscriptionHandshakeLink({ url, region, auth }),
]);

const client = new ApolloClient({
  link,
  defaultOptions: {
    watchQuery: {
      errorPolicy: "all",
    },
    query: {
      errorPolicy: "all",
    },
    mutate: {
      errorPolicy: "all",
    },
  },
  cache: new InMemoryCache({
    cacheRedirects: {
      Query: {
        playlistVideosByVideo: (_, args, { getCacheKey }) => {
          return getCacheKey({
            __typename: "$video",
            id: `${args.videoID}.playlistVideos`,
          });
        },
        playlistVideosByPlaylist: (_, args, { getCacheKey }) => {
          return getCacheKey({
            __typename: "$playlist",
            id: `${args.playlistID}.playlistVideos`,
          });
        },
      },
    },
  }),
});

ReactGA.initialize("UA-167570527-1", {});

ReactDOM.render(
  <ApolloProvider client={client}>
    <App />
  </ApolloProvider>,
  document.getElementById("root")
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
unregister();
